jQuery(function ($) {
  const FREE_GIFT_VARIANT_ID = 40109708935352; // Fettuccini with Pesto & Semi-dried Tomato (BXGY Free Gift | Gift w/ Purchase) // added by AMP

  var sellingPlan = {
    weekly: 691407192248,
    fortnightly: 691407225016,
    oneTime: null
  };

  switch(window?.loop_subscription_default) {
    case "subscribe-and-save":
      window.activeSellingPlanId = sellingPlan.weekly;
      break;
    case "one-time":
      window.activeSellingPlanId = sellingPlan.oneTime;
      break;
    default:
      window.loop_subscription_default = "subscribe-and-save";
      window.activeSellingPlanId = sellingPlan.weekly;
      break;
  }

  class SellingPlanHelper {

    static async getCartData() {
      if (window?.ZapietCart) {
        return window?.ZapietCart;
      }
      
      const res = await fetch(`/cart.js?app=loop`);

      if (!res.ok) {
        throw new Error('Failed to fetch cart: ', res.statusText);
      }

      return await res.json();
    }

    static async attachSellingPlanIDToCart(sellingPlanId) {
      document.dispatchEvent(new CustomEvent('subscription:start', { bubbles: true }))
      try {
        const data = await this.getCartData();

        const itemsToAdd = [];
        const itemsToRemove = {};

        for (const item of data.items) {
          if (item.selling_plan_allocation?.selling_plan?.id === sellingPlanId) {
            continue;
          }

          itemsToRemove[item.key] = 0;

          itemsToAdd.push({
            id: item.variant_id,
            quantity: item.quantity,
            selling_plan: sellingPlanId
          });
        }

        // Add items with the new selling plan ID attached
        let addResponse = await fetch('/cart/add.js?app=loop', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: itemsToAdd }),
        });

        if (!addResponse.ok) {
          throw new Error('Unable to add cart after update: ' + addResponse.statusText);
        }

        // Remove items by setting quantity to ZERO
        const updateResponse = await fetch('/cart/update.js?app=loop', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: itemsToRemove }),
        });

        if (!updateResponse.ok) {
          // mark that we haven't cleared cart, so restore is still safe
          throw new Error('Unable to update cart: ' + updateResponse.statusText);
        }

        console.log('Selling plan update completed.');
      } catch (error) {
        throw error;
      } finally {
        document.dispatchEvent(new CustomEvent('subscription:update', { bubbles: true }));
      }
    }

    static getSellingPlanLabel(sellingPlanId) {
      switch (sellingPlanId) {
        case sellingPlan.weekly:
          return 'Deliver every 1 week';
        case sellingPlan.fortnightly:
          return 'Deliver every 2 weeks';
        default:
          return 'One time';
      }
    }
  }

  class CartHelper {
    static setActionablesEnabled(enabled) {
      const cart = document.querySelector('#slidecarthq');

      const items = cart.querySelector('.items');
      if (items) {
        const itemsActionables = items.querySelectorAll('button');
        itemsActionables.forEach(button => {
          if (enabled == true) {
            button?.removeAttribute('disabled');
          } else {
            button?.setAttribute('disabled', enabled);
          }
        });
      }
    }

    static async updateCartUI() {
      try {
        const res = await fetch(`${window.location.origin}/cart`);
        const html = await res.text();

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        const cartBody = doc.querySelector('.cart-items tbody');

        if (!cartBody) {
          throw new Error('Fetching cart page error.');
        };

        const cartBodyRow = cartBody.querySelectorAll('tr');

        const subTotalEl = doc.querySelector('.cart-subtotal .cart-subtotal__price');

        if (!cartBodyRow) return;

        const cartBodyRowArray = Array.from(cartBodyRow);

        if (!cartBodyRowArray.length) return;

        // Items from drawer
        const drawerCartItems = document.querySelectorAll('#slidecarthq .items .item');

        if (!drawerCartItems.length) return;

        Array.from(drawerCartItems)?.forEach((drawerCartItem, index) => {
          const cartRowItem = cartBodyRowArray?.[index];

          // Update label
          const newlabelEl = cartRowItem.querySelector('.selling-plan-name');
          const newLabelText = (newlabelEl instanceof HTMLElement) ? newlabelEl?.textContent : 'One time';;

          // Remove existing subscription text if found
          const existingSubscriptionTexts = drawerCartItem.querySelectorAll('p.variants-p');
          if (existingSubscriptionTexts.length > 0) {
            for (const item of existingSubscriptionTexts) {
              item.remove();
            }
          }

          // Creatre new subscription label
          const newSubscriptionText = document.createElement('p');
          newSubscriptionText.classList.add('variants-p');
          newSubscriptionText.textContent = newLabelText;

          // Insert the new
          const drawerMainTopLeft = drawerCartItem.querySelector('.main-top-left');
          drawerMainTopLeft.appendChild(newSubscriptionText);

          // Update Price
          const priceDiscountBlock = drawerCartItem.querySelector('.price-discount-block');
          const priceDiscountBlockPrice = drawerCartItem.querySelectorAll('.price-discount-block .price');
          const newPrice = cartRowItem.querySelector('[data-cart-item-regular-price]');

          if (!priceDiscountBlockPrice.length || !newPrice) return;

          let priceTarget = priceDiscountBlockPrice?.[0];

          if (priceDiscountBlockPrice.length > 1) {
            const priceBlockArr = Array.from(priceDiscountBlockPrice);
            priceTarget = priceBlockArr?.[priceBlockArr.length - 1];
          }
          
          // commented-out by AMP for reference - start
          // const newPriceNormalized = String(newPrice.textContent ?? '').replace("Price: ", "").trim();

          // const priceSymbol = newPriceNormalized[0];

          // const newPriceAsNumber = newPriceNormalized.replace(priceSymbol,'');

          // // Get the quantity
          // const quantityEl = drawerCartItem.querySelector('.quantity-selector > input');
          // const newPriceRegulated = (newPriceAsNumber * quantityEl.value).toFixed(2);

          // // Update price times the quantity
          // priceTarget.textContent = `${priceSymbol}${newPriceRegulated}`;
          // commented-out by AMP for reference - end

          // added/updated by AMP - start
          // Get variant ID of the drawer item
          const itemVariantId = parseInt(drawerCartItem.dataset.variantId || 0);

          // Free gift handling
          if (itemVariantId === FREE_GIFT_VARIANT_ID) {
            priceTarget.textContent = `$0.00`;
          } else {
            const newPriceNormalized = String(newPrice.textContent ?? '').replace("Price: ", "").trim();
            const priceSymbol = newPriceNormalized[0];
            const newPriceAsNumber = newPriceNormalized.replace(priceSymbol, '');

            // Get the quantity
            const quantityEl = drawerCartItem.querySelector('.quantity-selector > input');
            const newPriceRegulated = (newPriceAsNumber * quantityEl.value).toFixed(2);

            // Update price times the quantity
            priceTarget.textContent = `${priceSymbol}${newPriceRegulated}`;
          }
          // added/updated by AMP - end

          // Update Subtotal
          const currentSubtotalEl = document.querySelector('.slidecart-subtotal');
          if (currentSubtotalEl) {
            currentSubtotalEl.textContent = subTotalEl?.textContent;
          }

          // Hide price stike-through when one time subscription is selected
          if (window.activeSellingPlanId == null) {
            priceDiscountBlock?.classList?.add('subscription--one-time');
          } else {
            priceDiscountBlock?.classList?.remove('subscription--one-time');
          }
        });
      } catch (error) {
        console.error('Update cart UI: ', error);
      }
    }

    static cartChangeViaQuantitySpinnerEventHandler() {
      const quantityIndicatorInputs = document.querySelectorAll('#slidecarthq .items .item .quantity-selector input[type="text"]');
      for(const quantityIndicatorInput of quantityIndicatorInputs) {
        const originalSetter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set
        Object.defineProperty(quantityIndicatorInput, 'value', {
          set: function(v) {
            originalSetter.call(this, v);
            CartHelper.updateCartUI();
          }
        });
      }
    }
  }


  class SellingPlanSelector extends HTMLElement {

    constructor() {
      super();

      const zcart = window?.ZapietCart;
      const zcartItem = zcart?.items?.[0];
      const _selling_plan_id = zcartItem?.selling_plan_allocation?.selling_plan?.id ?? null;
      
      if (zcartItem) {
        window.activeSellingPlanId = _selling_plan_id;
      }

      const shadow = this.attachShadow({ mode: 'open' });
      this.subscriptionChoice = 'weekly';

      const container = document.createElement('div');
      container.classList.add('selling-plan-selector');

      const title = document.createElement('h5');
      title.classList.add('selling-plan--title');
      const titleText = document.createTextNode('Is this a one-time order or subscription?');
      title.append(titleText);

      container.append(title);

      const subscribeRadioGroup = document.createElement('label');
      subscribeRadioGroup.classList.add('radio-group');
      subscribeRadioGroup.classList.add('active');

      this.subscribeRadio = document.createElement('input');
      this.subscribeRadio.type = 'radio';
      this.subscribeRadio.name = 'subscribe';

      const subscribeRadioText = document.createTextNode('Subscribe and save 10%');

      const onetimeRadioGroup = document.createElement('label');
      onetimeRadioGroup.classList.add('radio-group');

      this.oneTimeRadio = document.createElement('input');
      this.oneTimeRadio.type = 'radio';
      this.oneTimeRadio.name = 'subscribe';

      const onetimeRadioText = document.createTextNode('One time');

      const subscriptionOptionsContainer = document.createElement('div');
      subscriptionOptionsContainer.classList.add('subscription-options');

      const weeklyRadioGroup = document.createElement('label');
      weeklyRadioGroup.classList.add('radio-group-child');

      this.weeklyRadio = document.createElement('input');
      this.weeklyRadio.type = 'radio';
      this.weeklyRadio.name = 'subscription_type';

      const weeklyText = document.createTextNode('Every week');

      const fortnightlyRadioGroup = document.createElement('label');
      fortnightlyRadioGroup.classList.add('radio-group-child');

      this.fortnightlyRadio = document.createElement('input');
      this.fortnightlyRadio.type = 'radio';
      this.fortnightlyRadio.name = 'subscription_type';

      const fortnightlyText = document.createTextNode('Every 2 weeks');

      if (window.activeSellingPlanId === sellingPlan.weekly) {
        this.subscribeRadio.checked = true;
        this.weeklyRadio.checked = true;
        this.weeklyRadio.dataset.value = true;
      } else if (window.activeSellingPlanId === sellingPlan.fortnightly) {
        this.subscribeRadio.checked = true;
        this.fortnightlyRadio.checked = true;
        this.fortnightlyRadio.dataset.value = true;
      } else {
        this.oneTimeRadio.checked = true;
      }

      subscribeRadioGroup.appendChild(this.subscribeRadio);
      subscribeRadioGroup.appendChild(subscribeRadioText);

      onetimeRadioGroup.appendChild(this.oneTimeRadio);
      onetimeRadioGroup.appendChild(onetimeRadioText);

      weeklyRadioGroup.appendChild(this.weeklyRadio);
      weeklyRadioGroup.appendChild(weeklyText);
      subscriptionOptionsContainer.appendChild(weeklyRadioGroup);

      fortnightlyRadioGroup.append(this.fortnightlyRadio);
      fortnightlyRadioGroup.append(fortnightlyText);
      subscriptionOptionsContainer.appendChild(fortnightlyRadioGroup);

      if (window?.loop_subscription_default === 'subscribe-and-save') {
        container.appendChild(subscribeRadioGroup);
        container.appendChild(subscriptionOptionsContainer);
        container.appendChild(onetimeRadioGroup);
      } else if (window?.loop_subscription_default === 'one-time') {
        container.appendChild(onetimeRadioGroup);
        container.appendChild(subscribeRadioGroup);
        container.appendChild(subscriptionOptionsContainer);
      }

      shadow.innerHTML = `
                <style>
                    .selling-plan-selector {
                        display: flex;
                        flex-direction: column;
                        width: 100%;
                        margin-bottom: 32px;
                    }
                    .selling-plan--title {
                        font-size: 15px;
                        font-family: Obviously-Bold, sans-serif;
                        margin-bottom: 32px;
                    }
                    .subscription-options {
                        margin-top: 4px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-bottom: 20px;
                        height: auto;
                        overflow: hidden;
                        transition: height 150ms, margin-top 150ms;
                    }
                    .radio-group {
                        border: solid 2px #dcdcdc;
                        padding: 11px 10px;
                        display: block;
                        margin-bottom: 5px;
                        border-radius: 4px;
                        font-size: 10pt;
                        color: #0f2a06;
                        cursor: pointer;
                        transition: border-color 150ms;
                    }
                    .radio-group.active {
                        border-color: #8080d2;
                    }
                    .radio-group-child {
                        width: calc(42% - 5px);
                        font-size: 10pt;
                        text-align: center;
                    }
                    .subscription-options:not(:has(input[data-value='true'])) {
                        height: 0;
                        margin-top: 0;
                    }
                    .radio-group input[type='radio'],
                    .radio-group-child input[type='radio'] {
                        margin: 3px 5px;
                    }
                    .radio-group.disabled,
                    .radio-group-child.disabled {
                        border: solid 2px #dcdcdc;
                    }
                </style>
            `;
      shadow.append(container);

      this.onSelectSubscribeDefault = this.onSelectSubscribeDefault.bind(this);
      this.onSelectOneTime = this.onSelectOneTime.bind(this);
      this.onSelectFortnightly = this.onSelectFortnightly.bind(this);
      this.resetSelections = this.resetSelections.bind(this);
      this.setActive = this.setActive.bind(this);
    }

    connectedCallback() {
      this.subscribeRadio.addEventListener('change', this.onSelectSubscribeDefaultParent.bind(this));
      this.oneTimeRadio.addEventListener('change', e => this.onSelectOneTime(e));
      this.weeklyRadio.addEventListener('change', e => this.onSelectSubscribeDefault(e));
      this.fortnightlyRadio.addEventListener('change', e => this.onSelectFortnightly(e));
      document.addEventListener('subscription:update', CartHelper.updateCartUI);
      document.addEventListener('subscription:start', CartHelper.setActionablesEnabled.bind(this, false));
      document.addEventListener('subscription:update', CartHelper.setActionablesEnabled.bind(this, true));
      this.checkoutButtonEventListeners();
      CartHelper.cartChangeViaQuantitySpinnerEventHandler();
    }

    checkoutButtonEventListeners() {
      document.addEventListener('subscription:start', this.setCheckoutButtonEnabled.bind(this, true));
      document.addEventListener('subscription:update', this.setCheckoutButtonEnabled.bind(this, false));
    }

    setCheckoutButtonEnabled(enabled) {
      const checkoutButton = document.querySelector('button[name="checkout"]');

      if (!checkoutButton) return;

      // Checkout button isn't activated yet - Might be no items in the cart or customer haven't been able to set delivery date etc...
      if (checkoutButton.hasAttribute('disabled')) return;

      if (enabled) {
        checkoutButton.setAttribute('disabled', 'true');
        checkoutButton.style.opacity = 0.5;
      } else {
        checkoutButton.removeAttribute('disabled');
        checkoutButton.style.opacity = 1;
      }
    }

    disconnectedCallback() {
      this.subscribeRadio.removeEventListener('change', this.onSelectSubscribeDefaultParent.bind(this));
      this.oneTimeRadio.removeEventListener('change', e => this.onSelectOneTime(e));
      this.weeklyRadio.removeEventListener('change', e => this.onSelectSubscribeDefault(e));
      this.fortnightlyRadio.removeEventListener('change', e => this.onSelectFortnightly(e));
      document.removeEventListener('subscription:update', CartHelper.updateCartUI);
    }

    setLoading(isLoading) {
      const inputs = [
        this.subscribeRadio,
        this.oneTimeRadio,
        this.weeklyRadio,
        this.fortnightlyRadio,
      ];

      for (let input of inputs) {
        input.ariaDisabled = isLoading;

        if (isLoading) {
          input.setAttribute('disabled', true);
        } else {
          input.removeAttribute('disabled');
        }
      }

      if (isLoading) {
        this.subscribeRadio.parentElement.classList.add('disabled');
        this.oneTimeRadio.parentElement.classList.add('disabled');
      } else {
        this.subscribeRadio.parentElement.classList.remove('disabled');
        this.oneTimeRadio.parentElement.classList.remove('disabled');
      }
    }

    resetSelections() {
      this.shadowRoot.querySelectorAll('input[type="radio"').forEach(el => {
        el.checked = false;
        el.dataset.value = false;
      });
      this.shadowRoot.querySelectorAll('label').forEach(el => {
        el.classList.remove('active');
      });
    }

    setActive(e) {
      this.resetSelections();
      e.target.checked = true;
      e.target.dataset.value = true;

      if (e.target.name === 'subscription_type') {
        const parent = this.subscribeRadio;
        parent.parentElement.classList.add('active');
        parent.checked = true;
      }

      if (e.target === this.subscribeRadio) {
        const weekly = this.weeklyRadio;
        const fortnightly = this.fortnightlyRadio;
        if (!weekly.checked && !fortnightly.checked) {
          weekly.checked = true;
          weekly.dataset.value = true;
        }
      }

      if (e.target.name === 'subscribe') {
        e.target.parentElement.classList.add('active');
      }
    }

    setActiveUsingSellingPlan(sellingPlanId) {
      switch (sellingPlanId) {
        case sellingPlan.weekly:
          this.weeklyRadio.checked = true;
          this.subscribeRadio.checked = true;
          this.subscribeRadio.classList.add('active');

          this.oneTimeRadio.checked = false;
          this.oneTimeRadio.parentElement.classList.remove('active');
          break;
        case sellingPlan.fortnightly:
          this.fortnightlyRadio.checked = true;
          this.subscribeRadio.checked = true;
          this.subscribeRadio.classList.add('active');

          this.oneTimeRadio.checked = false;
          this.oneTimeRadio.parentElement.classList.remove('active');
          break;
      }
      window.activeSellingPlanId = sellingPlanId;
    }

    async attachSellingPlanIDToCart(sellingPlanId) {
      window.activeSellingPlanId = sellingPlanId;
      this.setLoading(true);
      try {
        await SellingPlanHelper.attachSellingPlanIDToCart(sellingPlanId);
      } catch (error) {
        console.error('Error: ', error);
      } finally {
        this.setLoading(false);
      }
    }

    onSelectSubscribeDefaultParent(e) {
      const event = new Event('change', { bubbles: true });
      this.weeklyRadio.dispatchEvent(event);
    }

    async onSelectSubscribeDefault(e) {
      this.setActive(e);
      await this.attachSellingPlanIDToCart(sellingPlan.weekly);
    }

    async onSelectOneTime(e) {
      this.setActive(e);
      await this.attachSellingPlanIDToCart(sellingPlan.oneTime);
    }

    async onSelectFortnightly(e) {
      this.setActive(e);
      await this.attachSellingPlanIDToCart(sellingPlan.fortnightly);
    }
  }

  if (!customElements.get('selling-plan-selector')) {
    customElements.define('selling-plan-selector', SellingPlanSelector);

    function attachSellingPlanSelectorUI() {
      cartCheckoutTriggerObserver.observe(document.querySelector('#slidecarthq'), { childList: true, subtree: true });

      $('#storePickupApp').append('<selling-plan-selector />');
      const button = document.querySelector('button[value="Checkout"][name="checkout"]');
      button?.setAttribute('disabled', true);
    }

    const sellingPlanSelectorObserver = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.target.id === 'storePickupApp') {
          if (!document.querySelector('selling-plan-selector')) {
            attachSellingPlanSelectorUI();
          }
        }
      }
    });
    sellingPlanSelectorObserver.observe(document.body, { childList: true, subtree: true });

    const cartCheckoutTriggerObserver = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        if (mutation.target.id === 'storePickupApp') {
          cartCheckoutTriggerObserver.disconnect();
        }
      }
    });
  }

});